import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressSidebar = ({ currentStep, totalSteps, completedSections, onSectionClick }) => {
  const sections = [
    { id: 'language', label: 'Language', icon: 'Languages' },
    { id: 'location', label: 'Location', icon: 'MapPin' },
    { id: 'workmode', label: 'Work Mode', icon: 'Laptop' },
    { id: 'experience', label: 'Experience', icon: 'Award' },
    { id: 'industry', label: 'Industry', icon: 'Briefcase' },
    { id: 'management', label: 'Management', icon: 'Users' },
    { id: 'business', label: 'Business', icon: 'TrendingUp' },
    { id: 'specialization', label: 'Specialization', icon: 'Target' }
  ];

  const progressPercentage = Math.round((currentStep / totalSteps) * 100);

  return (
    <aside className="hidden lg:block w-80 bg-card border-r border-border p-6 overflow-y-auto">
      <div className="mb-8">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-muted-foreground">Profile Completion</span>
          <span className="text-sm font-semibold text-primary">{progressPercentage}%</span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-all duration-500"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
      <nav className="space-y-2">
        {sections?.map((section, index) => {
          const isCompleted = completedSections?.includes(section?.id);
          const isCurrent = index === currentStep;
          const isAccessible = index <= currentStep;

          return (
            <button
              key={section?.id}
              onClick={() => isAccessible && onSectionClick(index)}
              disabled={!isAccessible}
              className={`w-full flex items-center gap-3 p-3 rounded-lg transition-all duration-250 text-left ${
                isCurrent
                  ? 'bg-primary/10 text-primary'
                  : isCompleted
                  ? 'text-foreground hover:bg-muted'
                  : 'text-muted-foreground opacity-50 cursor-not-allowed'
              }`}
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  isCurrent
                    ? 'bg-primary text-primary-foreground'
                    : isCompleted
                    ? 'bg-success text-success-foreground'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                {isCompleted ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <Icon name={section?.icon} size={20} />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium">{section?.label}</p>
                <p className="text-xs opacity-70">
                  {isCompleted ? 'Completed' : isCurrent ? 'In Progress' : 'Pending'}
                </p>
              </div>
            </button>
          );
        })}
      </nav>
      <div className="mt-8 p-4 rounded-xl bg-accent/10 border border-accent/20">
        <div className="flex gap-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center">
              <Icon name="Shield" size={20} color="var(--color-accent)" />
            </div>
          </div>
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Your Privacy Matters
            </p>
            <p className="text-xs text-muted-foreground">
              All information is kept anonymous. We never share identifying details with employers.
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ProgressSidebar;